// extracted by mini-css-extract-plugin
export default {"headerContainer":"page_headerContainer__hK9cL","logo":"page_logo__4xA4G","adminMenuLink":"page_adminMenuLink__VLi0y","active":"page_active__ZHXxE"};